import { AppRouteNamesList, IModuleRoute } from 'models';
import { CONSTANTS } from 'utils';
import { SurveyRoutePathList } from '../models';

export const surveyRoutes: IModuleRoute = {
	path: CONSTANTS.moduleSurveyPath,
	name: AppRouteNamesList.survey,
	nested: [
		{
			path: SurveyRoutePathList.module1,
			name: AppRouteNamesList.module1,
		},
		{
			path: SurveyRoutePathList.module2,
			name: AppRouteNamesList.module2,
		},
		{
			path: SurveyRoutePathList.module3,
			name: AppRouteNamesList.module3,
		},
		{
			path: SurveyRoutePathList.finish,
			name: AppRouteNamesList.finish,
		},
	],
};
